






















































import {Component, Vue, Watch} from 'vue-property-decorator';
import Table from '@c/tables/Table.vue';
import EditDialog from './MeasurementEditDialog.vue';
import {MeasurementTableHeader} from './interfaces';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {Can} from '@casl/vue';
import {PModuleType} from '@/enums/configs';
import {IpModuleInterface} from '../modules/interfaces';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {
    Table,
    EditDialog,
    Can,
  },
})
export default class Measurements extends Vue {
  pmoduleTypes: IpModuleInterface[] = [];
  typeSearch: PModuleType | null = null;

  get apiStore() {
    return measurementsStoreModule;
  }

  private editDialog = EditDialog;

  headers: MeasurementTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Тип программного модуля',
      value: 'moduleTypeDescription',
      sortable: true,
    },
    {
      text: 'Краткое наименование',
      value: 'shortName',
      sortable: true,
    },
    {
      text: 'Имя параметра',
      value: 'alias',
      sortable: true,
    },
    {
      text: 'Физическая величина',
      value: 'phys',
      sortable: true,
    },
    {
      text: 'Единицы измерения',
      value: 'unit',
      sortable: true,
    },
    {
      text: 'Обозначение оси X',
      value: 'xAxisDescription',
      sortable: true,
    },
    {
      text: 'Обозначение оси Y',
      value: 'yAxisDescription',
      sortable: true,
    },
    {
      text: 'Тип события',
      value: 'eventType',
      sortable: true,
    },
    {
      text: 'Тип измерения',
      value: 'typeDescription',
      sortable: true,
    },
  ];

  async created() {
    measurementsStoreModule.filterListAction(null);
    // Загрузка программных модулей
    const {data} = await httpClient.get<[]>(`module_types/`);
    if (data.length) {
      this.pmoduleTypes = data;
    }
  }

  // Фильтруем журнал по типу
  @Watch('typeSearch')
  onTypeSearch(type: any) {
    measurementsStoreModule.filterListAction(type);
  }

  importFile() {
    (this.$refs.fileInput as HTMLElement).click();
  }

  async onFileChanged(e: any) {
    if (!e.target.files[0]) return;

    const apiStore = this.apiStore;
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = async () => {
      const formData = new FormData();
      if (reader.result) {
        const blob = new Blob([reader.result], {type: file.type});
        formData.append('file', blob);
        await apiStore.import(formData);

        await apiStore.fetchAll();
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async exportFile() {
    const table: any = this?.$refs.table as any;
    const selected: any[] = table?.selectedItemsFromTable as any[];
    const data = await this.apiStore.export();
    const filtered = data.filter((elem: any) => selected.find(e => e.id == elem.id));

    const json = JSON.stringify(filtered, null, 2);
    const blob = new Blob([json], {type: 'text/plain'});
    const a = document.createElement('a');
    a.download = 'export_measurements.json';
    a.href = window.URL.createObjectURL(blob);
    a.click();
  }
}
